import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';

import { useSliceWrapper } from '~/hooks/use-slice-wrapper';

const customerSchema = z.object({
  urlCallback: z.string().nullable(),
});

const sliceStateSchema = z.object({
  customer: customerSchema,
  isInitialized: z.boolean().default(false),
});

type SliceState = z.infer<typeof sliceStateSchema>;

const initialState: SliceState = {
  /* contains the global states that are specific to the customer
  *  this will be used to store the customer global states
  *  create another store group for other global states to group states together
  */
  customer: {
    urlCallback: null,
  },
  isInitialized: false,
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    /* this will initialize the customer global store */
    initCustomerGlobalStore: (state) => {
      let values = initialState.customer;
      const stored = JSON.parse(localStorage.getItem('customer_store') || '{}');
      const parsedState = customerSchema.safeParse(stored);
      values = parsedState.success ? parsedState.data : initialState.customer;
      state.customer = values;
      state.isInitialized = true;
    },
    setCustomerUrlCallback: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      localStorage.setItem('customer_store', JSON.stringify({ ...state.customer, urlCallback: action.payload }));
      state.customer.urlCallback = action.payload;
    },
    clearCustomerUrlCallback: (state) => {
      localStorage.setItem('customer_store', JSON.stringify({ ...state.customer, urlCallback: null }));
      state.customer.urlCallback = null;
    },
    // 
  },
});

export const useGlobalSlice = () => useSliceWrapper(globalSlice, 'global');
export const GlobalStoreSlice = globalSlice.actions;
